import React from 'react';
import {injectIntl, intlShape} from 'react-intl';
import update from 'react-addons-update';
import NewGroup from './NewGroup'
import MenuBar from './MenuBar'
import {NEW_GROUP_FORM_STATE, CONVERSATION_TYPES} from './constants'
import {inject, observer} from "mobx-react";

@inject('uiStore', 'conversationsStore') @observer
class NewGroupContainer extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      participants: [],
      viewState: NEW_GROUP_FORM_STATE.PARTICIPANTS_SELECTION
    }
    this.handleAddParticipantClick = this.handleAddParticipantClick.bind(this);
    this.handleRemoveParticipantClick = this.handleRemoveParticipantClick.bind(this);
    this.handleParticipantsSubmit = this.handleParticipantsSubmit.bind(this);
    this.handleSubjectSubmit = this.handleSubjectSubmit.bind(this);
    this.handleClickBack = this.handleClickBack.bind(this);
    this.showParticipantsSelection = this.showParticipantsSelection.bind(this);
  }

  render(){
    return(
      <div>
        <MenuBar
          onClickBack={this.handleClickBack}
          showBackBtn={true}
          title={this.menuBarTitle()}
        />
        <NewGroup
          viewState={this.state.viewState}
          participants={this.state.participants}
          onParticipantsSubmit={this.handleParticipantsSubmit}
          onSubjectSubmit={this.handleSubjectSubmit}
          onAddParticipantClick={this.handleAddParticipantClick}
          onRemoveParticipantClick={this.handleRemoveParticipantClick}
        />
      </div>
    );
  }

  handleAddParticipantClick(contactId){
    this.setState({
      participants: update(this.state.participants, {$push: [contactId] }),
    });
  }

  handleRemoveParticipantClick(contactId){
    let index = this.state.participants.findIndex(
      (el) => el == contactId
    );
    if( index > -1 ){
      this.setState({
        participants: update( this.state.participants,
          {$splice: [[index, 1]] }
        )
      });
    } 
  }

  handleParticipantsSubmit(){
    let nextViewState = NEW_GROUP_FORM_STATE.PARTICIPANTS_SELECTION;
    if( this.state.participants.length > 0 ){
      nextViewState = NEW_GROUP_FORM_STATE.SUBJECT_DEFINITION;
    }
    this.setState({
      viewState: nextViewState,
    });
  }

  handleSubjectSubmit(subject){
    if( subject.length > 0 && this.state.participants.length > 0 ){
      this.props.uiStore.showLoading();
      this.props.conversationsStore.create(subject, null, this.state.participants, CONVERSATION_TYPES.GROUP );
    }
  }

  showParticipantsSelection(){
    this.setState({
      viewState: NEW_GROUP_FORM_STATE.PARTICIPANTS_SELECTION,
    });
  }

  /************** MENU BAR ****************************/
  handleClickBack(){
    switch(this.state.viewState){
      case NEW_GROUP_FORM_STATE.SUBJECT_DEFINITION:
        this.showParticipantsSelection();
        break;
      case NEW_GROUP_FORM_STATE.PARTICIPANTS_SELECTION:
      default:
        this.props.uiStore.handleClickBack();
    }
  }

  menuBarTitle(){
    let title ="";
    const {intl} = this.props;
    switch(this.state.viewState){
      case NEW_GROUP_FORM_STATE.PARTICIPANTS_SELECTION:
        title = intl.formatMessage({id: "new_group_participants_title"})
        break;
      case NEW_GROUP_FORM_STATE.SUBJECT_DEFINITION:
        title = intl.formatMessage({id: "new_group_subject_title"})
        break;
    }
    return title;
  }
  /****************************************************/

}

export default injectIntl(NewGroupContainer);